module.exports = __webpack_public_path__ + "static/img/jigou-jiangsu-bottom.3a045b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-jiangsu-bottom.png
// module id = rf3m
// module chunks = 2